import { useEffect, useState } from 'react';
import axios from 'axios';

export const VERSION_CHECK_INTERVAL_MINS = 5;

const useVersionCheck = (currentVersion: string) => {
  const [newVersion, setNewVersion] = useState<string | undefined>();

  useEffect(() => {
    if ('localhost' == location?.hostname) return;

    const checkVersion = async () => {
      try {
        const response = await axios.get('/app-version.json?' + Date.now());
        const latestVersion: string = response.data.version;
        if (latestVersion != currentVersion) {
          setNewVersion(latestVersion);
        }
      } catch {
        setNewVersion(undefined);
      }
    };

    checkVersion();
    const intervalId = setInterval(checkVersion, VERSION_CHECK_INTERVAL_MINS * 60 * 1000);

    return () => clearInterval(intervalId);
  }, [currentVersion]);

  return newVersion;
};

export default useVersionCheck;
